'use client';
import apiRequest from "@lib/api-fetch";

export async function getOptedOutStatus(phoneNumber: string): Promise<any> {
    const response = await apiRequest('GET', `/opt-out/check/${phoneNumber}`);
    return response.body;
}